import { Component, EventEmitter, Output } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FormFieldComponent } from '@shared/models/classes/FormFieldComponent';
import { CalendarModule } from 'primeng/calendar';
import { PmCalendarComponent } from '@shared/components/pm-calendar/pm-calendar.component';
import { DatePickerYearChangeEvent } from 'primeng/datepicker';

@Component({
  standalone: true,
  selector: 'pm-form-field-date',
  imports: [ReactiveFormsModule, CalendarModule, PmCalendarComponent],
  templateUrl: './pm-form-field-date.component.html',
  styleUrl: './pm-form-field-date.component.scss',
})
export class PmFormFieldDateComponent extends FormFieldComponent {
  @Output() monthChanged = new EventEmitter<DatePickerYearChangeEvent>();

  onMonthChanged($event: DatePickerYearChangeEvent) {
    this.monthChanged.emit($event);
  }
}
